module.exports = __webpack_public_path__ + "img/WindowKeyLight-StillLife.f889d7f4.jpeg";